import { Component, Input, OnInit } from '@angular/core';
import { FilterFieldValue } from '@app/apps/subscription/classes';
import { CellSetting } from '@app/layout/cell-setting';
import { LayoutService } from '@app/layout/layout.service';

@Component({
  selector: 'app-approval-decision-report',
  templateUrl: './approval-decision-report.component.html',
  styleUrls: ['./approval-decision-report.component.less'],
})
export class ApprovalDecisionReportComponent implements OnInit {
  @Input() groupedFilterFields: any[][];
  @Input() groupKeys: string[];
  filterFieldsVal: any[];
  @Input() set filterFields(value: any[]) {
    if (
      value != null &&
      value !== undefined &&
      value['filterFields'] != null &&
      value['filterFields'] !== undefined
    ) {
      this.filterFieldsVal = value['filterFields'];
    } else {
      this.filterFieldsVal = value;
    }
    this.getFilterGrouped();
    this.getFilterGroupKeys();
  }

  get filterFields(): any[] {
    return this.filterFieldsVal;
  }

  FilterActive = true;
  thereIsRes = 0;

  reportTableCols: any[];
  dataTable: { name: string; dataset: any[] };
  cellSettings: CellSetting[] = [];

  isLoading = false;

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    this.thereIsRes = 0;

    this.getReportFilterFields();
    this.getReportDataCols();

    this.dataTable = {
      name: '',
      dataset: [],
    };
    this.dataTable.name = 'approvalDecisionReport';

    this.layoutService.triggerRefreshReportResult.subscribe((parentName) => {
      if(parentName === 'CELL'){
        this.getReportResult();
      }
    });
  }

  getReportFilterFields(): void {
    this.layoutService.getFilterFields(50035).subscribe((d: any) => {
      let existingValues: { PropertyName: string; Value: any }[];

      if (this.filterFields !== undefined) {
        existingValues = this.filterFields.map((f) => {
          return { PropertyName: f.PropertyName, Value: f.Value };
        });
      }
      this.filterFields = [];
      this.filterFields = [...d.Data.fields];
      this.filterFields.forEach((element) => {
        let existingValue;
        if (existingValues !== undefined) {
          existingValue = existingValues.find(
            (f) => f.PropertyName === element.PropertyName
          );
        }

        if (
          existingValue === undefined &&
          element.DefaultValueSQLStatementId !== undefined &&
          element.DefaultValueSQLStatementId != null
        ) {
          this.layoutService
            .getDefaultValue(element.DefaultValueSQLStatementId)
            .subscribe((res: any) => {
              element.Value = res.DefaultValue;
              /*this.filterFieldsChange.emit({
                fieldName: element.FieldName,
                filterFields: this.filterFields,
              });*/
            });
        } else {
          if (existingValue !== undefined) {
            element.Value = existingValue.Value;
          }
        }
      });
    });
  }

  getFilterGroupKeys() {
    if (this.filterFields === undefined) {
      return;
    }
    this.groupKeys = [];
    this.filterFields.forEach((element) => {
      let key = element.AdditionalInformationParsed?.GroupInDialog;
      if (key === 'null' || key === null) {
        key = '';
      }
      if (this.groupKeys.indexOf(key) === -1) {
        this.groupKeys.push(key);
      }
    });

    this.groupKeys = this.groupKeys.sort();
  }

  getFilterGrouped() {
    if (this.filterFields === undefined) {
      return;
    }
    this.groupedFilterFields = this.filterFields.reduce((acc, obj) => {
      let key = obj.AdditionalInformationParsed?.GroupInDialog;
      if (key === 'null' || key === null) {
        key = '';
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    console.log(this.groupedFilterFields);
  }

  getReportDataCols(): void {
    this.layoutService.getSectionTableColumns(50036).subscribe((d: any) => {
      console.log({ invoicingTableCols: JSON.parse(d.cols) });
      this.reportTableCols = JSON.parse(d.cols);
    });
  }

  getReportResult(): void {
    this.isLoading = true;
    this.dataTable = {
      name: '',
      dataset: [],
    };

    console.log('this.filterFields', this.filterFields);
    this.dataTable.name = 'approvalDecisionReport';

    const filterData: FilterFieldValue[] = [];
    if (this.filterFields != null && this.filterFields !== undefined) {
      for (const filterField of this.filterFields) {
        if (filterField.Value != null && filterField.Value[0] !== '') {
          filterData.push({
            FieldName: filterField.FieldName,
            Value: filterField.Value,
          });
        } else {
          filterData.push({ FieldName: filterField.FieldName, Value: [''] });
        }
      }
    }

    this.layoutService
      .getDataFromQuery(80081, filterData)
      .subscribe((d: any) => {
        this.dataTable.dataset = d.table.rowsArray;
        this.cellSettings = [];
        this.isLoading = false;
        this.FilterActive = false;
      });
  }

  formatterNumber(value: number): string {
    if (value == null || value === 0 || isNaN(value)) {
      return '';
    }

    return `${Number(value).toFixed(0).toString()}`;
  }
}
